import {
  watchApprovePageDraft,
  watchDeletePageAtom,
  watchDeletePageDraft,
  watchForkPageAtom,
  watchGetPagesAtom,
  watchGetPagesDraft,
  watchLoadMorePagesAtom,
  watchLoadMorePagesDraft,
  watchRejectPageDraft,
  watchCreateUserPageCategory,
  watchGetCategoriesOfPageProduct,
  watchHotfixPageAtom,
  watchCommitPageDraft,
  watchPublishPageAtom,
  watchEnableShopifyPageAtom,
  watchDisableShopifyPageAtom,
  watchEnableShopifyPageDraft,
  watchDisableShopifyPageDraft,
  watchDeleteCategoryOfPageProduct,
  watchUpdateCategoryOfPageProduct,
} from './store/sagas';

export * from './Pages';
export { PageManagement as default } from './Pages';

export const sagasPageManagement = [
  watchApprovePageDraft,
  watchDeletePageAtom,
  watchDeletePageDraft,
  watchForkPageAtom,
  watchGetPagesAtom,
  watchGetPagesDraft,
  watchLoadMorePagesAtom,
  watchLoadMorePagesDraft,
  watchRejectPageDraft,
  watchCreateUserPageCategory,
  watchGetCategoriesOfPageProduct,
  watchHotfixPageAtom,
  watchCommitPageDraft,
  watchPublishPageAtom,
  watchEnableShopifyPageAtom,
  watchDisableShopifyPageAtom,
  watchEnableShopifyPageDraft,
  watchDisableShopifyPageDraft,
  watchDeleteCategoryOfPageProduct,
  watchUpdateCategoryOfPageProduct,
];
